module.exports = __webpack_public_path__ + "img/shield-checkmark-outline-2.553bef90.svg";